import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))

const AiProfileInfo = lazy(() =>
	import('./AiProfileInfo').then((module) => ({ default: module.AiProfileInfo })),
)

class AiProfileInfoComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<AiProfileInfo />
			</RootProviders>
		)
	}
}

customElements.define('ai-profile-info', AiProfileInfoComponent)
